import React from "react";
import Icon from "./AppIcon";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    error.__ErrorBoundary = true;
    window.__COMPONENT_ERROR__?.(error, errorInfo);
    // console.log("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="text-center p-8 max-w-md card">
            <div className="flex justify-center items-center mb-4">
              <div className="w-16 h-16 bg-error-100 rounded-full flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
              </div>
            </div>
            <div className="flex flex-col gap-4 text-center">
              <h1 className="text-2xl font-semibold text-text-primary">Something went wrong</h1>
              <p className="text-text-secondary text-base">We encountered an unexpected error while processing your request. Please try refreshing the page or go back to home.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
              <button
                onClick={() => {
                  window.location.reload();
                }}
                className="btn-secondary flex items-center justify-center gap-2 px-6 py-3"
              >
                <Icon name="RefreshCw" size={18} />
                Refresh
              </button>
              <button
                onClick={() => {
                  window.location.href = "/";
                }}
                className="btn-primary flex items-center justify-center gap-2 px-6 py-3"
              >
                <Icon name="Home" size={18} />
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;